export default {
  stepPrepare: "Preparar pago",
  stepProcess: "Procesar pago",
  stepConfirm: "Confirmar pedido",
  preparing: "Preparando el entorno de pago",
  confirmingPayment: "Confirmando el pago",
  confirmingOrder: "Confirmando el pedido",
  possibleIssue: "Posible problema detectado",
  settingUp: "Configurando un pago seguro…",
  waitingConfirmation: "Esperando confirmación de la transacción…",
  updatingAccount: "Actualizando la información de su cuenta…",
  paymentSuccessful: "¡Pago exitoso!",
  upgradeSuccess: "Su plan se ha actualizado con éxito.",
  continue: "Continuar",
  somethingWentWrong: "Algo salió mal con su pago.",
  tryAgain: "Intentar nuevamente",
  paymentCancelled: "Pago cancelado",
  cancelledTransaction: "Ha cerrado la ventana de pago o cancelado la transacción.",
  timeoutMessage:
    "Puede haber ocurrido un problema. Puede verificar si sus beneficios han surtido efecto. Si necesita ayuda, por favor contacte a nuestro soporte en {supportEmail}.",
  secureEncrypted: "Sus datos bancarios están cifrados de forma segura",
  havingTrouble: "¿Tiene problemas? Contacte a {supportEmail}",
};
